import { render, staticRenderFns } from "./CourseIndex.vue?vue&type=template&id=c3029a20&scoped=true&"
import script from "./CourseIndex.vue?vue&type=script&lang=js&"
export * from "./CourseIndex.vue?vue&type=script&lang=js&"
import style0 from "./CourseIndex.vue?vue&type=style&index=0&id=c3029a20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3029a20",
  null
  
)

export default component.exports